import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import {
  CHANGE_PASSWORD_ROUTE,
  extractHttpErrorMessage,
  isDeadSessionError,
  isInactiveUserError,
  isIncompleteProfileError,
  isMinorGuardianError,
  isMustChangePasswordError,
  profileBlockRoute,
} from '@/app/core/auth/auth-http.utils';
import { AuthService } from '@/app/core/auth/auth.service';
import { NotificationsService } from '@/app/core/services/notifications/notifications.service';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const notifications = inject(NotificationsService);

  return next(req).pipe(
    catchError((err) => {
      if (
        isInactiveUserError(err) &&
        req.url.includes('/auth/check-status')
      ) {
        authService.logout();
        void notifications.usuarioInactivo();
      }

      if (isDeadSessionError(err, req.url, !!authService.getToken())) {
        authService.logout();
      }

      if (
        isMustChangePasswordError(err) &&
        !req.url.includes('/auth/change-password') &&
        !router.url.startsWith(CHANGE_PASSWORD_ROUTE)
      ) {
        authService.markPasswordChangeRequired();
        void router.navigateByUrl(CHANGE_PASSWORD_ROUTE);
      }

      // Perfil incompleto (spec 39). Las rutas de escape quedan fuera: el backend
      // no las bloquea, y reaccionar a ellas convertiría el aviso en un loop.
      const isEscapeRoute =
        req.url.includes('/auth/') || req.url.includes('/clients/me');

      // Sin sesión no se navega: si `checkStatus` ya la limpió, mandar al panel
      // deja el shell montado sin token y todo en blanco. Ahí manda el authGuard.
      const skip = isEscapeRoute || !authService.getToken();

      if (!skip && (isMinorGuardianError(err) || isIncompleteProfileError(err))) {
        const message = extractHttpErrorMessage(err);
        authService.incompleteProfileMessage.set(message);
        const destino = profileBlockRoute(message);
        if (!router.url.startsWith(destino)) void router.navigateByUrl(destino);
      }

      return throwError(() => err);
    })
  );
};
